import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-SrpMenuScrollable" */'@components/searchPage/SrpMenuScrollable'), {
  fallbackProps: { className: 'is-hidden' },
});
